import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setNameError, setUniqueNameError } from '../../features/createBudget/createBudgetSlice';
import Input from '../reusable/Input/Input';
import ErrorField from './ErrorField';
import LabelField from './LabelField';

const BudgetNameInput = ({ value, error, onChange }) => {
  const dispatch = useDispatch();

  const handleClearNameErrors = useCallback(() => {
    dispatch(setNameError(''));
    dispatch(setUniqueNameError(''));
  }, [dispatch]);

  const handleChange = useCallback(
    e => {
      handleClearNameErrors();
      onChange(e.target.value);
    },
    [onChange, handleClearNameErrors],
  );

  return (
    <>
      <LabelField>Budget Name</LabelField>
      {error && <ErrorField>{error}</ErrorField>}
      <Input
        name="name"
        value={value || ''}
        styled="mb15"
        type="text"
        placeholder="Enter Your Budget Name"
        onChange={handleChange}
      />
    </>
  );
};

BudgetNameInput.propTypes = {
  value: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BudgetNameInput;
